export default __webpack_public_path__ + "static/media/prod4.9e963437.png";